import Colors from '../../../../constants/Colors'
import {
  KYC_DECISION,
  KYC_REASON_ID_CARD,
  KYC_CUSTOMER_CITIZENSHIP,
  KYC_STATUSES,
  KYC_CARD_TYPE,
} from '../../constants'
import { Card, Col, Form } from 'react-bootstrap'
import { useCallback, useState } from 'react'
import PropTypes from 'prop-types'
import KYCForeignerForm from './KYCForeignerForm'
import KYCThaiForm from './KYCThaiForm'

const KYCIdCardForm = ({
  userKYCDataRef,
  decision,
  setDecision,
  invalid,
  setInvalid,
  cardInfo,
  setUserKYCData,
  reasons,
  setReasons,
}) => {
  const [nation, setNation] = useState(KYC_CUSTOMER_CITIZENSHIP.THAI)
  const [stayType, setStayType] = useState(null)
  const [cardType, setCardType] = useState(KYC_CARD_TYPE.PASSPORT)

  const handleChangeRadioIdCard = (e) => {
    setDecision(e.target.value)
    setReasons([])
    if (e.target.value === KYC_STATUSES.APPROVED) {
      setInvalid((prevInvalid) => ({ ...prevInvalid, reasonIdCard: false }))
    }
  }

  const handleChangeCheckboxIdCard = (e) => {
    const value = e.target.value
    let updatedItems
    setInvalid((prevInvalid) => ({ ...prevInvalid, reasonIdCard: false }))
    if (reasons.includes(value)) {
      updatedItems = reasons.filter((item) => item !== value)
    } else {
      updatedItems = [...reasons, value]
    }
    setReasons(updatedItems)
  }

  const resetCardInfo = useCallback(() => {
    setUserKYCData((prev) => ({
      ...prev,
      cardInfo: { ...prev.cardInfo, ...userKYCDataRef.current.cardInfo },
    }))
  }, [userKYCDataRef, setUserKYCData])

  return (
    <Card style={{ width: '100%', borderWidth: '1px', borderColor: Colors.LIGHT_GREY2 }}>
      <Card.Body>
        <div style={{ width: '100%', textAlign: 'center', overflow: 'hidden', height: '300px' }}>
          <img
            alt=""
            style={{ width: '100%', height: '100%', objectFit: 'contain', objectPosition: 'center' }}
            src={cardInfo.url}
          />
        </div>
        <Form>
          <h4 className="py-2">การตรวจสอบข้อมูลบุคคล</h4>
          <Form.Group>
            {KYC_DECISION.map(({ value, label }) => {
              return (
                <Form.Check
                  key={value}
                  value={value}
                  label={label}
                  type="radio"
                  onChange={handleChangeRadioIdCard}
                  checked={decision === value}
                  required
                  isInvalid={invalid.decisionIdCard}
                />
              )
            })}
            <Form.Control.Feedback type="invalid" style={{ display: invalid.decisionIdCard ? 'block' : 'none' }}>
              กรุณาเลือก
            </Form.Control.Feedback>
          </Form.Group>
          {decision === 'REJECTED' && (
            <Form.Group>
              <Form.Label>ข้อมูลบัตรประชาชน ไม่ถูกต้อง :</Form.Label>
              <Col sm="9">
                {KYC_REASON_ID_CARD.map((reason) => {
                  return (
                    <Form.Check
                      key={reason}
                      value={reason}
                      label={reason}
                      type="checkbox"
                      onChange={handleChangeCheckboxIdCard}
                      checked={reasons.includes(reason)}
                      isInvalid={invalid.reasonIdCard}
                    />
                  )
                })}
              </Col>
              <Form.Control.Feedback type="invalid" style={{ display: invalid.reasonIdCard ? 'block' : 'none' }}>
                กรุณาเลือกอย่างน้อย 1 รายการ
              </Form.Control.Feedback>
            </Form.Group>
          )}
          {decision === 'APPROVED' && (
            <>
              <h4 className="py-2">กรุณาเลือกสัญชาติ</h4>
              <Form.Group>
                <Form.Check
                  value={KYC_CUSTOMER_CITIZENSHIP.THAI}
                  label="คนไทย"
                  type="radio"
                  onClick={() => {
                    setNation(KYC_CUSTOMER_CITIZENSHIP.THAI)
                    resetCardInfo()
                  }}
                  onChange={() => {
                    setNation(KYC_CUSTOMER_CITIZENSHIP.THAI)
                  }}
                  checked={nation === KYC_CUSTOMER_CITIZENSHIP.THAI}
                  required
                />
                <KYCThaiForm
                  nation={nation}
                  cardType={cardType}
                  setCardType={setCardType}
                  cardInfo={cardInfo}
                  setUserKYCData={setUserKYCData}
                  stayType={stayType}
                  setStayType={setStayType}
                />
              </Form.Group>
              <Form.Group>
                <Form.Check
                  value={KYC_CUSTOMER_CITIZENSHIP.FOREIGNER}
                  label="ชาวต่างชาติ"
                  type="radio"
                  onChange={() => {
                    setNation(KYC_CUSTOMER_CITIZENSHIP.FOREIGNER)
                    resetCardInfo()
                  }}
                  checked={nation === KYC_CUSTOMER_CITIZENSHIP.FOREIGNER}
                  required
                />
                <KYCForeignerForm
                  nation={nation}
                  cardType={cardType}
                  setCardType={setCardType}
                  cardInfo={cardInfo}
                  setUserKYCData={setUserKYCData}
                  stayType={stayType}
                  setStayType={setStayType}
                />
              </Form.Group>
            </>
          )}
        </Form>
      </Card.Body>
    </Card>
  )
}

KYCIdCardForm.propTypes = {
  decision: PropTypes.string.isRequired,
  setDecision: PropTypes.func.isRequired,
  invalid: PropTypes.object.isRequired,
  setInvalid: PropTypes.func.isRequired,
  cardInfo: PropTypes.object.isRequired,
  setUserKYCData: PropTypes.func.isRequired,
  reasons: PropTypes.array.isRequired,
  setReasons: PropTypes.func.isRequired,
}

export default KYCIdCardForm
